<template>
  <s-page v-if="loaded">
    <template v-slot:lateral-panel>
      <s-lateral-panel>
        <v-text-field v-model="recherche" placeholder="Rechercher" hide-details dense clearable class="ma-2" />
        <perfect-scrollbar style="height: 100%" id="associations">
          <v-list>
            <v-list-item-group color="primary">
              <template v-for="(association, index) in associationList">
                <association-list-item :key="index + 1" :association="association" />
                <v-divider v-if="index < associationList.length - 1" :key="-(index + 1)"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </perfect-scrollbar>
        <association-create-dialog v-if="isInRole('Administrateur')" />
      </s-lateral-panel>
    </template>
    <template v-slot:main-panel>
      <router-view />
    </template>
  </s-page>
</template>

<script>
import associationCreateDialog from '../../components/etablissement/association-create-dialog'
import associationListItem from '../../components/etablissement/association-list-item'
import { mapGetters } from 'vuex'
import { initialDataLoaded } from '../../store/modules/helpers'
import SLateralPanel from '@/components/global/s-lateral-panel.vue'
import SPage from '@/components/global/s-page.vue'

export default {
  name: 'association',
  components: {
    SPage,
    SLateralPanel,
    associationCreateDialog,
    associationListItem,
  },
  data() {
    return {
      recherche: null,
    }
  },
  computed: {
    ...initialDataLoaded,
    ...mapGetters({
      associations: 'etablissement/getAssociations',
      isInRole: 'security/isInRole',
    }),
    loaded() {
      return initialDataLoaded && this.associations
    },
    associationList() {
      if (this.recherche === null || this.recherche === '') {
        return this.associations
      } else {
        return this.associations.filter(
          (et) => et.raisonSociale.toLowerCase().indexOf(this.recherche.toLowerCase()) <= -1
        )
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
